(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["relaxim-art-direction"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reduced.matches || !!navigator.connection?.saveData;
  const scenes = new Map();
  const allowed = () => !paused && !document.hidden && document.body.classList.contains('rlx-store-ready');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = scenes.get(entry.target);
      if (state) { state.visible = entry.isIntersecting; syncScene(entry.target, state); }
    });
  }, { rootMargin: '80px' });

  function syncScene(video, state) {
    if (!allowed() || !state.visible) { video.pause(); return; }
    if (!state.loaded) {
      const mobile = matchMedia('(max-width: 749px)').matches;
      const src = mobile ? (video.dataset.mobile || video.dataset.mobileMp4) : (video.dataset.desktop || video.dataset.desktopMp4);
      if (!src) return;
      video.muted = true;
      video.defaultMuted = true;
      video.src = src;
      state.loaded = true;
    }
    video.play().catch(() => {});
  }

  function syncMotion() {
    document.documentElement.classList.toggle('rlx-motion-paused', paused);
    document.querySelectorAll('[data-rlx-motion]').forEach(button => {
      button.setAttribute('aria-pressed', String(paused));
      button.querySelector('[data-rlx-motion-label]').textContent = paused ? button.dataset.play : button.dataset.pause;
      button.querySelector('.rlx-motion__icon').textContent = paused ? '▷' : 'Ⅱ';
    });
    scenes.forEach((state, video) => syncScene(video, state));
  }

  function setup(root = document) {
    if (!document.querySelector('[data-rlx-motion]')) {
      const scene = document.querySelector('.article-template,.rlx-blog-scene');
      const template = document.getElementById('rlx-scene-motion-template');
      if (scene && template) scene.prepend(template.content.cloneNode(true));
    }
    root.querySelectorAll('[data-rlx-ambient-video],.rlx-smoke-atmosphere__video').forEach(video => {
      if (scenes.has(video)) return;
      scenes.set(video, { visible: false, loaded: false });
      video.addEventListener('playing', () => {
        video.classList.add('is-playing');
        video.closest('.rlx-smoke-atmosphere')?.classList.add('rlx-smoke-video-playing');
      });
      video.addEventListener('error', () => {
        video.classList.remove('is-playing');
        video.closest('.rlx-smoke-atmosphere')?.classList.remove('rlx-smoke-video-playing');
      });
      observer.observe(video);
    });
    root.querySelectorAll('[data-rlx-motion]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.hidden = false;
      button.addEventListener('click', () => { paused = !paused; syncMotion(); });
    });
    root.querySelectorAll('[data-rlx-collection-tools]').forEach(bar => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const section = bar.closest('.rlx-products');
      const cards = [...section.querySelectorAll('[data-rlx-category]')];
      const buttons = [...bar.querySelectorAll('[data-rlx-filter]')];
      const counter = bar.querySelector('[data-rlx-filter-count]');
      if (!cards.length) return;
      bar.hidden = false;
      const filter = category => {
        let visible = 0;
        cards.forEach(card => {
          card.hidden = category !== 'all' && card.dataset.rlxCategory !== category;
          if (!card.hidden) visible++;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rlxFilter === category)));
        counter.textContent = counter.dataset.format.replace('__COUNT__', String(visible));
      };
      buttons.forEach(button => {
        if (button.dataset.rlxFilter !== 'all' && !cards.some(card => card.dataset.rlxCategory === button.dataset.rlxFilter)) button.hidden = true;
        button.addEventListener('click', () => filter(button.dataset.rlxFilter));
      });
      filter('all');
    });
    syncMotion();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  else setup();
  addEventListener('relaxim:store-ready', syncMotion);
  document.addEventListener('visibilitychange', syncMotion);
  reduced.addEventListener('change', event => { paused = event.matches; syncMotion(); });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    scenes.forEach((state, video) => {
      if (event.target.contains(video)) { video.pause(); observer.unobserve(video); scenes.delete(video); }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
